<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="账户名称：">
        <el-input v-model="dataForm.username" placeholder="账户名" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="企业名称：">
        <el-input v-model="dataForm.companyName" placeholder="企业名" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button @click="batchAdd()" type="primary" v-if="isAuth('user:addBatch')">批量新增</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()" v-if="isAuth('user:add')">新增</el-button>
        <el-button type="success" @click="userExcel()">导出Excel</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0" v-if="isAuth('user:delete')">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)" stripe :header-cell-style="{ background: '#fafafa' }"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="ID" width="60">
      </el-table-column>
      <el-table-column prop="username" header-align="center" align="center" label="账户名称">
      </el-table-column>
      <el-table-column prop="companyName" header-align="center" align="center" label="所属企业">
      </el-table-column>
      <el-table-column prop="roleName" header-align="center" align="center" label="角色">
      </el-table-column>
      <el-table-column prop="mobile" header-align="center" align="center" label="手机号">
      </el-table-column>
      <el-table-column prop="email" header-align="center" align="center" label="邮箱号">
      </el-table-column>
      <el-table-column prop="nickName" header-align="center" align="center" label="微信昵称">
      </el-table-column>
      <el-table-column prop="description" header-align="center" align="center" label="备注">
      </el-table-column>
      <el-table-column header-align="center" align="center" width="180" label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="重置密码" placement="top">
            <img src="../../assets/img/czmm.png" alt="" width="18" height="18"
              style="margin-right: 10px;vertical-align: text-bottom;cursor: pointer;"
              v-if="isAuth('user:password:reset')" @click="resetPwdHandle(scope.row.id)">
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="解除绑定" placement="top">
            <el-button v-if="isAuth('user:wechat:unbind')" type="text" @click="unbindHandle(scope.row.id)"
              style="font-size: 18px;padding: 0;"><i class="el-icon-link"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="addOrUpdateHandle(scope.row.id)" v-if="isAuth('user:update')"><i
                class="el-icon-edit-outline"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="deleteHandle(scope.row.id)" v-if="isAuth('user:delete')"><i
                class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="密钥" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="createAppIdSecret(scope.row)" v-if="isAuth('user:createAppId')"><i
                class="el-icon-key"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

    <!-- 密钥 -->
    <el-dialog title="APP权限信息" :visible.sync="appIdVisible" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="400px">
      <el-form :model="form" style="margin-top: 10px;">
        <el-form-item label="appId:">
          <el-input v-model="form.appId" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="appSecret:">
          <el-input v-model="form.appSecret" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appIdVisible = false">取 消</el-button>
        <el-button type="primary" @click="appIdUpdate(appId)"
          :disabled="this.form.appId != null && this.form.appId != ''">生成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from './user-add-or-update'
import { excel, isAuth } from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        params: ''
      },
      form: {
        appId: '',
        appSecret: ''
      },
      options: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      appIdVisible: false,
      appId: ''
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList()
  },
  methods: {
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('user/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'username': this.dataForm.username,
          'companyName': this.dataForm.companyName,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 批量新增
    batchAdd() {
      this.$router.replace({ path: '/indexhome/batchAdd/userIndex' });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/user/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 密钥
    createAppIdSecret(id) {
      this.appIdVisible = true
      this.form.appId = id.appId
      this.form.appSecret = id.appSecret
      this.appId = id.id

    },
    appIdUpdate(val) {
      this.$http({
        url: this.$http.adornUrl('user/createAppIdSecret'),
        method: 'post',
        data: this.$http.adornData({
          'id': val
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList()
          this.appIdVisible = false
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    //解除微信公众号绑定
    unbindHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '解除绑定' : '批量解除绑定'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("/user/unbind/wechat"),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //excel
    userExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/user/excel", "账号信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'username': this.dataForm.username,
        'companyName': this.dataForm.companyName,
      }, loading.close(), this.$message({
        message: '导出成功',
        type: 'success',
        duration: 3000,
        showClose: true,
        onClose: () => { }
      })
      )
    },
    //获取企业
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl('/company/option'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.options = data.data.companyOption;
        }
      })
    },
    //重置密码
    resetPwdHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '重置密码' : '批量重置密码'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/user/password/reset'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/user.vue